import { CountryCode } from "./country-code.js";
import { CurrencyCode } from "./currency-code.js";
import { CurrencySymbol } from "./currency-symbol.js";
import { LanguageCode } from "./language-code.js";
//#region src/domain/i18n/locale-factory.ts
var createLocaleFromCountryCode = (countryCode) => {
	if (countryCode === CountryCode.DO) return {
		currencyCode: CurrencyCode.DOP,
		currencySymbol: CurrencySymbol.DOP,
		languageCode: LanguageCode.ES_DO
	};
	else if (countryCode === CountryCode.HN) return {
		currencyCode: CurrencyCode.HNL,
		currencySymbol: CurrencySymbol.HNL,
		languageCode: LanguageCode.ES_HN
	};
	else return {
		currencyCode: CurrencyCode.GTQ,
		currencySymbol: CurrencySymbol.GTQ,
		languageCode: LanguageCode.ES_GT
	};
};
//#endregion
export { createLocaleFromCountryCode };

//# sourceMappingURL=locale-factory.js.map